import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
export var lmFetch = function lmFetch() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  try {
    if (!options.url) {
      throw new Error('Le param \'url\' est obligatoire : Ex : {url: \'https://www.leroymerlin.fr\'}');
    }

    // Data object for fetch call
    var opt = {
      method: 'GET',
      headers: {
        'Content-Type': 'text/html',
        'Cache': 'no-cache'
      },
      credentials: 'same-origin'
    };
    for (var k in options) {
      if (k !== 'url' && k !== 'callback' && k !== 'data') {
        opt[k] = options[k];
      }
    }

    // callback functions
    var callback = {
      // eslint-disable-next-line no-console
      success: options.success || function (data) {
        console.log(data);
      },
      // eslint-disable-next-line no-console
      error: options.error || function (data) {
        console.log(data);
      },
      // eslint-disable-next-line no-console
      complete: options.complete || function () {
        return true;
      }
    };

    // Query parameters
    var esc = encodeURIComponent;
    var query = options.data ? Object.keys(options.data).map(function (k) {
      return "".concat(esc(k), "=").concat(esc(options.data[k]));
    }).join('&') : '';
    var url = options.url;
    if (url.indexOf('?') > -1) {
      url = "".concat(url, "&").concat(query);
    } else if (query !== '') {
      url = "".concat(url, "?").concat(query);
    }
    fetch(url, opt).then(function (response) {
      var fetchResult = {
        status: response.status,
        headers: response.headers
      };
      if (response.ok) {
        // vérifier que le code de statut est bien compris entre 200 et 299 inclus
        response.text().then(function (data) {
          callback.success(data, fetchResult);
          callback.complete();
        });
      } else {
        response.text().then(function (data) {
          callback.error(data, fetchResult);
          callback.complete();
        });
      }
    })["catch"](function (error) {
      callback.error(error, {
        status: 500,
        headers: new Headers({})
      });
      callback.complete();
    });
  } catch (e) {
    return false;
  }
};